<div class="container-fluid">
    <div class="row progress-bar-container">
        <emm-progress-bar [isLoading$]="isLoading$"></emm-progress-bar>
    </div>
</div>
<div class="banner">
    <emm-menu-banner [effectiveDate]="effectiveDate$ | async" [isFutureDate]="isFutureDate$ | async"
                     [selectedConsumer]="selectedConsumer$ | async"
                     [selectedFeatureScope]="selectedFeatureScope$ | async"
                     [selectedSubmenu]="(selectedSearchSubmenu$ | async) ? (selectedSearchSubmenu$ | async) :
                            (selectedSubmenu$ | async)"
                     [selectedLocation]="selectedLocationSet$"
                     [enablePublishButton]="canPublish | async"
                     [selectedLocationType]="selectedLocationSetType$ | async"
                     [selectedVenue]="selectedVenue$ | async"
                     [selectedEffectiveDate]="effectiveDate$" [isSuperAdmin]="isSuperAdmin" [isAdmin]="isAdmin"
                     [downloadMenuTooltip]="menuLastPublishedString | async"
                     (publishButtonClicked)="handlePublishButtonClicked()"
                     (downloadMenuButtonClicked)="handleDownloadMenuClicked($event)"
                     (downloadItemsReportButtonClicked)="handleDownloadItemsReportClicked($event)"
                     (addOrEditChangeSet)="updateChangeSet()"
                     (viewChangeSets)="viewChangeSets()"
                     [isSubmenuCacheEnabled]="isSubmenuCacheEnabled" (clearSubmenuCache)="clearSubmenuCache()"
                     [style.width]="centerPaneWidth">
    </emm-menu-banner>
    <div class="row global-header">
        <emm-menu-header-global *ngIf="(selectedFeatureScope$ | async) === 'Global' && selectedLocationSet$ | async"
                                [selectedConsumer]="selectedConsumer$ | async"
                                [selectedLocation]="selectedLocationSet$ | async"
                                (add)="createGlobalSubMenu()" (searchButtonClicked)="onFilter($event)"
                                (clearSearchButtonClicked)="exitSearchMode()" (sortByName)="sortByName()"
                                (sortByTag)="sortByTag()" (expandAll)="expandAll = $event"
                                (expandChecked)="expandChecked = $event">
        </emm-menu-header-global>
        <emm-menu-key-header *ngIf="(selectedFeatureScope$ | async) !== 'Global'"
                             [selectedFeatureScope]="selectedFeatureScope$ | async"
                             [selectedConsumer]="selectedConsumer$ | async"
                             [selectedLocation]="selectedLocationSet$ | async" (add)="createSubMenu()"
                             [contentLoading]="isLoading$ | async" (searchButtonClicked)="onFilter($event)"
                             (clearSearchButtonClicked)="exitSearchMode()"
                             [selectedEffectiveDate]="effectiveDate$" [isSuperAdmin]="isSuperAdmin" [isAdmin]="isAdmin">
        </emm-menu-key-header>
    </div>
</div>
<div class="w-100 menu-tree-content"
     [style.padding-bottom]="((selectedFeatureScope$ | async) !== 'Viewer') ? '50px' : '0px'">
    <div class="progress-bar-container">
        <emm-progress-bar [isLoading$]="isLoading$"></emm-progress-bar>
    </div>

    <!-- Search by tag results -->
    <main *ngIf="isSearchMode$ | async">
        <div class="progress-bar-container search-progress">
            <emm-progress-bar *ngIf="isSearching | async" [isLoading$]="isSearching"></emm-progress-bar>
        </div>
        <div id="searchSnackbar" *ngIf="!(searchFailed | async)">
            <strong>Please wait for the search to complete</strong>
            <p>It might take a few seconds depending on the number of results.</p>
            <br>
            <p>
                Please note, the results may not accurately show whether an item is disabled or not. You can click on
                the item and view the status in the right pane.
            </p>
        </div>
        <div id="searchFailed" *ngIf="(searchFailed | async)">
            <strong>There were no results for that tag</strong>
            <p>Please try again.</p>
        </div>
        <emm-generic-items-tree *ngIf="!(isSearching | async)"
                                [items]="filteredMenuTree$ | async"
                                [options]="options"
                                [readonly]="isReadOnly$ | async"
                                [searchedTag]="searchedTag$ | async"
                                [contextMenuActions]="searchTreeContextMenuActions"
        ></emm-generic-items-tree>
    </main>

    <!-- Menu Viewer -->
    <main *ngIf="((selectedFeatureScope$ | async) === 'Viewer') && (selectedLocationSet$ | async) &&
    (selectedConsumer$ | async) && !(isSearchMode$ | async)">
        <emm-item-detail-tree [isLoading]="isLoading$ | async" [items]="items$ | async" [options]="options"
                              [readonly]="isReadOnly$ | async" [selectedFeatureScope]="selectedFeatureScope$ | async"
                              [selectedConsumer]="selectedConsumer$ | async"
                              [selectedLocation]="selectedLocationSet$ | async"
                              class="col w-100"
                              *ngIf="selectedConsumer$ | async"></emm-item-detail-tree>
    </main>

    <!-- Global menu builder -->
    <main
        *ngIf="(selectedFeatureScope$ | async) === 'Global' && (selectedLocationSet$ | async)  && !(isSearchMode$ | async)">
        <div [style.overflow-y]="'scroll'">
            <mat-accordion>
                <mat-expansion-panel *ngFor="let node of nodes$ | async" (opened)="handlePanelExpand(node)"
                                     (closed)="handlePanelClose(node)" class="expansion-panel">
                    <mat-expansion-panel-header class="cma-expansion-panel-header">
                        <div class="cma-container">
                            <div class="cma-right">
                                <div class="cma-name">{{node.name}}
                                    <mat-icon *ngIf="node.id.includes('_R1')"
                                              class="new-submenu-icon"
                                              matTooltip="This submenus uses some Common Items">
                                        fiber_new
                                    </mat-icon>
                                </div>
                                <div class="cma-id">{{node.id}}</div>
                            </div>
                        </div>
                    </mat-expansion-panel-header>
                    <mat-divider></mat-divider>
                    <div class="submenu-content">
                        <div class="progress-bar-container">
                            <emm-progress-bar [isLoading$]="isLoadingSubmenuItems$"></emm-progress-bar>
                        </div>
                        <div *ngIf="(selectedSubmenu$ | async) === node.id">
                            <div *ngIf="(isLoadingSubmenuItems$ | async) === false">
                                <emm-item-detail-tree [expandFirstNode]="true" [isLoading]="isLoading$ | async"
                                                      [items]="items$ | async" [options]="options"
                                                      [readonly]="isReadOnly$ | async"
                                                      [selectedFeatureScope]="selectedFeatureScope$ | async"
                                                      [selectedConsumer]="selectedConsumer$ | async"
                                                      [copyAcrossSubmenu]="isCopied"
                                                      [selectedLocation]="selectedLocationSet$ | async"
                                                      (addItem)="addItem($event)"
                                                      (pasteItemCascade)="pasteItemCascade($event)"
                                                      (copyItem)="copyItem($event)"
                                                      (deleteItem)="deleteItem($event)"
                                                      (deleteItemCascade)="deleteItemCascade($event)"
                                                      (moveItem)="moveItem($event)"
                                                      (pasteItem)="pasteItem($event)"
                                                      (toggleItemDisabled)="toggleItemDisabled($event)"
                                                      (treeState)="setTreeState($event)">
                                </emm-item-detail-tree>
                                <div id="copiedSnackbar">
                                    <span style="color: #679a7a; position: relative; top: 5px; margin-right: 3px;"><mat-icon>done</mat-icon></span>
                                    <strong>Copied to clipboard</strong>
                                    <button mat-icon-button class="close" (click)="closeCopiedSnackbar()">
                                        <mat-icon matTooltip="Close this message">close</mat-icon>
                                    </button>
                                    <br>
                                    <ul style="list-style-type: circle">
                                        <li>Select a node in a submenu, right click and <strong>Paste Item</strong>
                                            <br>
                                            or
                                        </li>
                                        <li>Select a node in a submenu, right click and <strong>Paste Cascade</strong>
                                            to add it to multiple submenus
                                        </li>
                                    </ul>
                                </div>
                                <div id="moveFailed">
                                    <strong>The item could not be moved.</strong>
                                    <p>Please make sure the item does not exist on the target position.</p>
                                    <p>Please wait for the menu to reload the item back to its original position.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </main>

    <!-- Consumer menu assignment -->
    <main
        *ngIf="(selectedFeatureScope$ | async) === 'Client' && (selectedLocationSet$ | async) && !(isSearchMode$ | async)">
        <!-- CMA Select View -->
        <div *ngIf="!showCheckedSubmenusOnly">
            <mat-accordion>
                <div *ngFor="let node of selectViewNodes">
                    <mat-expansion-panel (opened)="handlePanelExpand(node)"
                                         (closed)="handlePanelClose(node)" class="expansion-panel">
                        <mat-expansion-panel-header class="expansion-panel-header">
                            <div class="cma-left" *ngIf="!showCheckedSubmenusOnly">
                                <!-- stopPropagation to stop panel opening when clicking checkbox -->
                                <mat-checkbox (click)="$event.stopPropagation()"
                                              (keydown)="$event.stopPropagation()" [checked]="node.assigned"
                                              (change)="handleCheckboxSubmenu(node, $event)">
                                </mat-checkbox>
                            </div>
                            <div class="cma-container row w-100">
                                <div class="cma-right" [style]="'margin-left: 10px;'">
                                    <div class="cma-name">{{node.name}}</div>
                                    <div class="cma-id">{{node.id}}</div>
                                </div>
                            </div>
                        </mat-expansion-panel-header>
                        <mat-divider></mat-divider>
                        <div class="submenu-content">
                            <div class="progress-bar-container">
                                <emm-progress-bar [isLoading$]="isLoadingSubmenuItems$"></emm-progress-bar>
                            </div>
                            <div *ngIf="(selectedSubmenu$ | async) === node.id">
                                <div *ngIf="(isLoadingSubmenuItems$ | async) === false">
                                    <emm-item-detail-tree [expandFirstNode]="true" [isLoading]="isLoading$ | async"
                                                          [items]="items$ | async" [options]="options"
                                                          [readonly]="isReadOnly$ | async"
                                                          [selectedFeatureScope]="selectedFeatureScope$ | async"
                                                          [selectedConsumer]="selectedConsumer$ | async"
                                                          [selectedLocation]="selectedLocationSet$ | async"></emm-item-detail-tree>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </div>
            </mat-accordion>
        </div>

        <!-- CMA Preview and Sort View -->
        <div *ngIf="showCheckedSubmenusOnly" id="cma-sort" cdkScrollable>
            <mat-accordion
                cdkDropList (cdkDropListDropped)="drop($event)">
                <div *ngFor="let node of sortedPreviewNodes" cdkDrag [cdkDragDisabled]="panelExpanded">
                    <mat-expansion-panel (opened)="handlePanelExpand(node)"
                                         (closed)="handlePanelClose(node)" class="expansion-panel">
                        <mat-expansion-panel-header class="cma-expansion-panel-header">
                            <div>
                                <div class="cma-name">{{node.name}}</div>
                                <div class="cma-id">{{node.id}}</div>
                            </div>
                        </mat-expansion-panel-header>
                        <mat-divider></mat-divider>
                        <div class="submenu-content">
                            <div class="progress-bar-container">
                                <emm-progress-bar [isLoading$]="isLoadingSubmenuItems$"></emm-progress-bar>
                            </div>
                            <div *ngIf="(selectedSubmenu$ | async) === node.id">
                                <div *ngIf="(isLoadingSubmenuItems$ | async) === false">
                                    <emm-item-detail-tree [expandFirstNode]="true" [isLoading]="isLoading$ | async"
                                                          [items]="items$ | async" [options]="options"
                                                          [readonly]="isReadOnly$ | async"
                                                          [selectedFeatureScope]="selectedFeatureScope$ | async"
                                                          [selectedConsumer]="selectedConsumer$ | async"
                                                          [selectedLocation]="selectedLocationSet$ | async"></emm-item-detail-tree>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </div>
            </mat-accordion>
        </div>
    </main>

</div>
<div class="row row-bottom" [style.width]="centerPaneWidth" *ngIf="(selectedFeatureScope$ | async) !== 'Viewer'">
    <emm-items-controls-footer [showSaveButton]="showSaveButton" [disabled]="isReadOnly$ | async"
                               [isLoading]="isLoading$ | async" [featureScope]="selectedFeatureScope$ | async"
                               [consumer]="selectedConsumer$ | async" [location]="selectedLocationSet$ | async"
                               [showNextButton]="showNextButton" [contentLoading]="isLoading$ | async"
                               [submenu]="selectedSubmenu$ | async"
                               [isDragAndDropEnabled]="isDragAndDropEnabled$ | async"
                               (handleChange)="toggleDragAndDrop($event)"
                               (saveAssignments)="handleSaveAssignments()" (cancel)="resetToInitialView()"
                               (nextButtonClicked)="handleNextButtonClicked()"
    ></emm-items-controls-footer>
</div>
